import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.Home.Awards.heading',
    defaultMessage: 'Nagrody i wyróżnienia:'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Awards/Awards.intl.js